import {useContext, useEffect, useState} from "react";
import AppContext from "../AppContext";

export default function OldVersion() {
    const app = useContext(AppContext)
    const [go, setGo] = useState(false)
    useEffect(() => {
        window.localStorage.setItem('token', '');
        setGo(true)
    }, [app])

    useEffect(() => {
        if(go)
            window.location.href = process.env.REACT_APP_OLD_VERSION_URL
    }, [go])
    return (<div>Redirecting to old version...</div>)
}